module.exports = __webpack_public_path__ + "static/img/lian.6b1df22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lian.svg
// module id = z5LJ
// module chunks = 1